const wrap = (toWrap, wrapperClass = '', wrapper) => {
  wrapper = wrapper || document.createElement('div');
  wrapper.classList.add(wrapperClass);
  toWrap.parentNode.insertBefore(wrapper, toWrap);
  return wrapper.appendChild(toWrap);
};

export default wrap;
